import ISO_3166_1_ALPHA_2_CODES from "@payair/e-com-common-sdk/isoCodes/iso3166Alpha2Codes"
import { getCountryCallingCode } from "@payair/e-com-common-sdk/phone/CountryCallingCodes"
import { CountryCallingCode } from "./CountryCallingCode.model"

const getFlagEmoji = (countryCode: string): string =>
  countryCode.replace(/[A-Z]/g, character => String.fromCodePoint(127397 + character.charCodeAt(0)))

export const getCountryCallingCodes = (displayLanguage: string): CountryCallingCode[] => {
  const displayNames = new Intl.DisplayNames([displayLanguage], { type: "region" })

  return ISO_3166_1_ALPHA_2_CODES.map((countryCode): CountryCallingCode | undefined => {
    const callingCode = getCountryCallingCode(countryCode)
    if (!callingCode) {
      return undefined
    }

    return {
      countryCode,
      callingCode,
      emoji: getFlagEmoji(countryCode),
      name: displayNames.of(countryCode) || countryCode,
    }
  })
    .filter((country): country is CountryCallingCode => country !== undefined)
    .sort((left, right) => left.name.localeCompare(right.name, displayLanguage))
}
